<script setup lang="ts">
import { inject, onMounted } from "vue";
import Mousetrap from "mousetrap";
import { useRouter } from "vue-router";
import { ConfigProvider } from "reka-ui";

import RsMessage from "@/components/Message.vue";

const CSP_NONCE = inject<string>("NONCE");

const $router = useRouter();
onMounted(() => {
  Mousetrap.bind("l v", () => {
    $router.push({ name: "logs" });
  });
});
</script>

<template>
  <ConfigProvider :nonce="CSP_NONCE">
    <div id="popper-portal" />
    <div id="modals-portal" />
    <RsMessage />
    <router-view />
  </ConfigProvider>
</template>
